const breakpoints = {
  sm: "440px",
  md: "768px",
  lg: "1024px",
  xl: "1200px",
  "2xl": "1400px",
};

export default breakpoints;
